import Main from './Main'
import FriendGetFriend from './FriendGetFriend'
import BvpQuestions from './BvpQuestions'

export default {
  Main,
  FriendGetFriend,
  BvpQuestions
}



// WEBPACK FOOTER //
// ./src/components/Activity/index.js